import { inject, InjectionToken } from '@angular/core';

import { LocalStorageService } from '@cosmos/data-access-storage';

import type { RoleControl } from './feature-flags-role-control.component';

export const LOCAL_STORAGE_ROLE_KEY = 'role' as const;

export const DEV_TOOLBAR_ROLE_CONTROL = new InjectionToken<RoleControl>(
  ngDevMode ? 'DEV_TOOLBAR_ROLE_CONTROL' : '',
  {
    providedIn: 'root',
    factory: () => {
      const _localStorageService = inject(LocalStorageService);
      return {
        role: _localStorageService.getItem(LOCAL_STORAGE_ROLE_KEY) || null,
      };
    },
  }
);
